import { Icon } from '@natera/material/lib/icon'
import { IconButton, Text } from '~/shared/ui'
import type { StagedFile } from '../../model/types'
import { useUploadQueueStore } from '../../model/use-upload-queue-store'

interface UploadModalFileRowProps {
  staged: StagedFile
}

export function UploadModalFileRow({ staged }: UploadModalFileRowProps): React.ReactElement {
  const handleRemove = (): void => {
    useUploadQueueStore.getState().removeStagedFile(staged.id)
  }

  return (
    <div className="border-divider bg-surface-low flex items-center gap-2 rounded-lg border px-4 py-2">
      <div className="flex min-w-0 flex-1 flex-col">
        <Text
          appearance="BODY2"
          className="text-text-primary truncate"
        >
          {staged.file.name}
        </Text>
        {!staged.isSupported && (
          <Text
            appearance="CAPTION"
            className="text-alert-error-message"
          >
            Unsupported file type
          </Text>
        )}
      </div>

      {!staged.isSupported && (
        <Icon
          className="text-alert-error-message"
          children="warning"
        />
      )}
      <IconButton
        size="small"
        container="small"
        onClick={handleRemove}
        aria-label="Remove file"
      >
        <Icon children="delete" />
      </IconButton>
    </div>
  )
}
